<mat-dialog-content>
  <lemon-dialog-header> Valitse tila </lemon-dialog-header>

  <form novalidate style="margin: 0">
    <div style="padding-left: 3em; padding-right: 3em; padding-bottom: 1em">
      <mat-radio-group style="display: flex; flex-direction: column; margin: 15px 0" #grouppi aria-label="Valitse tila" (change)="tallenna()" [formField]="lomake.tila">
        <mat-radio-button #radbut [value]="null" style="margin: 5px">
          <span style="font-weight: bold">Tilaa ei valittu</span>
        </mat-radio-button>
        @for (tila of tilat; track tila) {
          <mat-radio-button #radbut [value]="tila" style="margin: 5px">
            <span style="font-weight: bold" [class]="tila.vari">{{ tila.nimi }}</span> {{ tila.kuvaus }}
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 3em; padding-right: 3em">
  <app-secondary-button mat-dialog-close actionId="Sulje dialog (asiakkaan kirjanpitäjän sarakkeen arvon muokkaus)">Sulje</app-secondary-button>
</mat-dialog-actions>
